import ENDPOINTS from '@/config/http/endpoints'
import { parseResponse } from '@/config/http/http.helpers'
import { mapLoginResponse } from '@/ducks/auth/auth.helpers'
import {
  ApiLoginResponse,
  ApiLoginResponseSchema
} from '@/ducks/auth/auth.types'
import { rootApi } from '@/ducks/root.api'

export const authApi = rootApi.injectEndpoints({
  endpoints: build => ({
    login: build.mutation<
      ReturnType<typeof mapLoginResponse>,
      { email: string; password: string }
    >({
      query: data => ({
        method: 'POST',
        url: ENDPOINTS.LOG_IN,
        noAuth: true,
        skipAuth: true,
        data
      }),
      transformResponse: (response: ApiLoginResponse) => {
        const typedResponse = parseResponse(response, ApiLoginResponseSchema)
        return mapLoginResponse(typedResponse)
      }
    })
  })
})

// export const { useExampleQuery } = extendedApi
export const { useLoginMutation } = authApi
